import { SECTION_ID_MAPPING } from '#src/app/pages/petitionDetails/shared/constants';

import { useScrollToSection } from '../../hooks/useScrollToSection';

import { SignaturesDistributionContainer } from './components/SignaturesDistributionContainer';
import { SupporterVoices } from './components/SupporterVoices';
import { useSupporterVoicesSection } from './components/SupporterVoices/hooks/useSupporterVoicesSection';
import { TheSupportersTitle } from './components/TheSupportersTitle';
import { TheSupportersContextProvider, useTheSupportersContext } from './shared/context';

type Props = {
	// Computed once in Main.tsx (it also drives the page layout wrapper) and passed down so
	// the feed/legacy decision can't diverge between the wrapper and the content.
	showSupporterVoicesFeed: boolean;
};

const TheSupportersInner: React.FC<Props> = ({ showSupporterVoicesFeed }) => {
	const {
		data: { showSupporterVoicesSection },
	} = useSupporterVoicesSection();

	const {
		data: { hasMap },
	} = useTheSupportersContext();

	const {
		data: { refs },
	} = useScrollToSection();

	return (
		<div id={SECTION_ID_MAPPING.SUPPORTER_VOICES} ref={refs[SECTION_ID_MAPPING.SUPPORTER_VOICES]}>
			<div className="mb-6 lg:mb-16">
				{showSupporterVoicesSection ? (
					<>
						<TheSupportersTitle />
						<SupporterVoices showSupporterVoicesFeed={showSupporterVoicesFeed} />
					</>
				) : null}
				{hasMap ? <SignaturesDistributionContainer /> : null}
			</div>
		</div>
	);
};

export const TheSupporters: React.FC<Props> = ({ showSupporterVoicesFeed }) => {
	return (
		<TheSupportersContextProvider>
			<TheSupportersInner showSupporterVoicesFeed={showSupporterVoicesFeed} />
		</TheSupportersContextProvider>
	);
};
